import { cn } from '#app/utils/misc.tsx'

export function Logo(props: React.SVGProps<SVGSVGElement>) {
	return <img alt="logo" src="/img/logo.png" className={cn('h-6 w-6 rounded-full', props.className)} />
}
